import BaseAPI from "../base";

class VersionService extends BaseAPI {
  // HIS客户信息检索
  getVersion(params) {
    return this.post({
      url: "/api/app-update/version/get",
      data: params,
    });
  }
}

export default new VersionService();
